var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticStyle:{"text-align":"center"},attrs:{"title":_vm.title,"visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('video',{attrs:{"src":_vm.src,"controls":"","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }